import moment from "moment"

export const formatDate = (date: string, format: string = "DD MMM YYYY, HH:mm") => {
  moment.locale("ru")
  return moment(date).format(format)
}
